"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHIPPING_CRITERIA_OPERATORS_BY_OPTIONS = exports.SHIPPING_CRITERIA_OPERATOR = void 0;
const shippingCriteriaOption_1 = require("./shippingCriteriaOption");
const GREATER = 'GREATER';
const LOWER = 'LOWER';
const EQUAL = 'EQUAL';
const INCLUDES = 'INCLUDES';
const EXCLUDES = 'EXCLUDES';
exports.SHIPPING_CRITERIA_OPERATOR = {
    GREATER,
    LOWER,
    EQUAL,
    INCLUDES,
    EXCLUDES
};
exports.SHIPPING_CRITERIA_OPERATORS_BY_OPTIONS = {
    [shippingCriteriaOption_1.SHIPPING_CRITERIA_OPTION.DTG_PRODUCT_ID]: [INCLUDES],
    [shippingCriteriaOption_1.SHIPPING_CRITERIA_OPTION.SIZE]: [INCLUDES],
    [shippingCriteriaOption_1.SHIPPING_CRITERIA_OPTION.ORDER_WEIGHT]: [GREATER, LOWER, EQUAL],
    [shippingCriteriaOption_1.SHIPPING_CRITERIA_OPTION.PLATFORM_SALE_SOURCE]: [EQUAL],
    [shippingCriteriaOption_1.SHIPPING_CRITERIA_OPTION.SHIPPING_METHOD]: [INCLUDES, EXCLUDES]
};
//# sourceMappingURL=shippingCriteriaOperator.js.map